import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { PageSection } from '../../../../../../Layout';
import WholePortionDryMassesSection from './WholePortionDryMassesSection';
import WholePortionWetMassesSection from './WholePortionWetMassesSection';

let WholePortionMassesPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isInitiallyDry = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.StateAfterInitialPreparation'),
      (s: StateOfMaterial) => s === StateOfMaterial.OvenDry
    )
  );

  return (
    <PageSection heading={`Sieve Portion Mass`}>
      {isInitiallyDry ? <WholePortionDryMassesSection /> : <WholePortionWetMassesSection />}
    </PageSection>
  );
};

WholePortionMassesPageSection = withInjectedProps(WholePortionMassesPageSection);

export { WholePortionMassesPageSection };
export default WholePortionMassesPageSection;
